export const staleTimes = {
  fifteenMinutes: 1000 * 60 * 15,
  fiveMinutes: 1000 * 60 * 5,
  none: 0,
  oneDay: 1000 * 60 * 60 * 24,
  oneMinute: 1000 * 60,
  twentySeconds: 1000 * 20,
};

/**
 * Shared key for the FSA receipt download mutations (useFSAReceiptBlobs) so components
 * rendered away from the caller (e.g. DownloadReceiptButton) can observe an in-flight
 * download via useIsMutating. Lives here rather than in useFSAReceiptBlobs so web-safe
 * consumers don't transitively import react-native-blob-util.
 */
export const FSA_RECEIPT_MUTATION_KEY = ['fsaReceipt'];
